import { render, staticRenderFns } from "./SharedLayout.vue?vue&type=template&id=041a2038"
import script from "./SharedLayout.vue?vue&type=script&lang=js"
export * from "./SharedLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports